import { simpleLookupConfig } from "../../../shared/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "machineCabinetType";

const url = "/api/machines/MachineCabinetType";

export const machineCabinetTypeLookupConfig = simpleLookupConfig({
  name: vsObjectName,
  nameSingular: "Cabinet Type",
  url,
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
});
